import { GalleryOptions_Layout_Type as GALLERY_LAYOUT } from './../ricos-schema/next-schema';

export const layoutRicosData = {
  [GALLERY_LAYOUT.COLLAGE]: {
    layout: {
      type: 'COLLAGE',
      orientation: 'COLUMNS',
      horizontalScroll: false,
    },
    item: {
      crop: 'FILL',
      targetSize: 300,
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.MASONRY]: {
    layout: {
      type: 'MASONRY',
      orientation: 'ROWS',
      numberOfColumns: 0,
    },
    item: {
      crop: 'FILL',
      targetSize: 300,
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.GRID]: {
    layout: {
      type: 'GRID',
      orientation: 'COLUMNS',
      horizontalScroll: false,
      numberOfColumns: 3,
    },
    item: {
      crop: 'FILL',
      ratio: 1,
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.THUMBNAIL]: {
    layout: {
      type: 'THUMBNAIL',
      orientation: 'ROWS',
    },
    item: {
      crop: 'FILL',
    },
    thumbnails: {
      placement: 'BOTTOM',
      spacing: 5,
    },
  },
  [GALLERY_LAYOUT.SLIDER]: {
    layout: {
      type: 'SLIDER',
      orientation: 'ROWS',
    },
    item: {
      crop: 'FIT',
      ratio: 16 / 9,
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.SLIDESHOW]: {
    layout: {
      type: 'SLIDESHOW',
      orientation: 'ROWS',
    },
    item: {
      crop: 'FILL',
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.PANORAMA]: {
    layout: {
      type: 'PANORAMA',
      orientation: 'ROWS',
    },
    item: {
      crop: 'FILL',
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.COLUMN]: {
    layout: {
      type: 'COLUMN',
      orientation: 'ROWS',
    },
    item: {
      crop: 'FILL',
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
  [GALLERY_LAYOUT.FULLSIZE]: {
    layout: {
      type: 'FULLSIZE',
      orientation: 'ROWS',
    },
    item: {
      crop: 'FILL',
    },
    thumbnails: {
      placement: 'NONE',
    },
  },
} as const;
